import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import Header from "../../components/Header/Header";
import CardGrid from "../../components/CardGrid/CardGrid";
import Footer from "../../components/Footer/Footer";
import MenuBar from "../../components/MenuBar/MenuBar";
import Filters from "../../components/FilterSection/FilterSection"; 
import { useDataContext } from "../../components/DataContext/PortfolioDataContext";


const Landing: React.FC = () => {
  const { accounts } = useMsal();
  const navigate = useNavigate();

  // Use context for filters and data
  const { filters, setFilters ,searchQuery, setSearchQuery } = useDataContext();

  const [isFiltersOpen, setIsFiltersOpen] = useState(false);
  const [refreshCounter, setRefreshCounter] = useState(0);
  
  const handleRefresh = () => {
    sessionStorage.removeItem("apiDataFetched");
    setRefreshCounter((prev) => prev + 1); 
  }; 

  useEffect(() => {
    if (!accounts || accounts.length === 0) {
      navigate("/"); 
    }
  }, [accounts, navigate]);

  

  const handleApplyFilter = (filtersData: any) => {
    // Apply filters directly from the context
    setFilters({
      selectedAssetType: filtersData.filters.asset_type.value[0] || '',
      selectedISO: filtersData.filters.iso.value[0] || '',
      sortField: filtersData.sort_by?.split(' ')[0] || '',
      sortOrder: filtersData.sort_by?.split(' ')[1] as 'Ascending' | 'Descending' || 'Ascending',
      groupByField: filtersData.group_by || ''
    });
    
  };

  

  return (
    <div className="flex flex-col min-h-screen bg-[#F7F7FF]">
      {/* Header */}
      <Header />
      {/* MenuBar with filter toggle */}
      <MenuBar onFilterToggle={() => setIsFiltersOpen(!isFiltersOpen)}  searchQuery={searchQuery}
  setSearchQuery={setSearchQuery} onRefresh={handleRefresh}/>

      <div className="flex-grow relative">
        {/* Main Content (CardGrid) */}
        <CardGrid
          selectedAssetType={filters.selectedAssetType}
          selectedISO={filters.selectedISO}
          sortBy={filters.sortField}
          sortOrder={filters.sortOrder}
          groupBy={filters.groupByField}
          searchQuery={searchQuery}
          refreshCounter={refreshCounter}
        />
      </div>

      {/* Footer */}
      <Footer />

      {/* Overlay for the filter popup */}
      {isFiltersOpen && (
        <div
          className="fixed inset-0 bg-black opacity-50 z-40"
          onClick={() => setIsFiltersOpen(false)}     
        ></div>
      )}

      {/* Filter Section - Appears as a popup on the right with animation */}
      <div
        className={`fixed top-24 right-0 bottom-0 w-70 sm:w-70 z-50 bg-white shadow-lg transform transition-all duration-500 overflow-y-auto
          ${isFiltersOpen ? "opacity-100 translate-x-0" : "opacity-0 translate-x-full"}`}
        style={{
          maxHeight: "calc(97vh - 96px)",
          minHeight: "calc(85vh - 96px)",
        }}
      >
        <Filters setIsFiltersOpen={setIsFiltersOpen} onApplyFilter={handleApplyFilter} />
      </div>
    </div>
  );
};

export default Landing;
